module.exports = __webpack_public_path__ + "img/38_43.a9ac81a2.png";